import { render, staticRenderFns } from "./PostingConfigurationForm.vue?vue&type=template&id=c034f6b2"
import script from "./PostingConfigurationForm.vue?vue&type=script&lang=js"
export * from "./PostingConfigurationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports